<div class="checkout-container">
  <div class="checkout-header">
       
    <div class="header-content">
      <h1>{{ t('checkout') }}</h1>
      <p>{{ t('completeYourOrder') }}</p>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="checkout-content">
    <!-- Left Column - Form -->
    <div class="form-column">
      <div class="checkout-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <h2>{{ t('deliveryAddress') }}</h2>
        </div>
        
        <form [formGroup]="checkoutForm" (ngSubmit)="placeOrder()">
          <div class="form-row">
            <div class="form-group">
              <label for="fullName">
                <i class="fas fa-user"></i>
                {{ t('fullName') }} *
              </label>
              <div class="input-wrapper">
                <input type="text" id="fullName" formControlName="fullName" [placeholder]="t('enterFullName')"
                  class="form-control" [class.error]="checkoutForm.get('fullName')?.invalid && checkoutForm.get('fullName')?.touched">
                <div class="input-icon">
                  <i class="fas fa-user"></i>
                </div>
              </div>
              <div class="error-message"
                *ngIf="checkoutForm.get('fullName')?.invalid && checkoutForm.get('fullName')?.touched">
                <i class="fas fa-exclamation-triangle"></i>
                <span *ngIf="checkoutForm.get('fullName')?.errors?.['required']">{{ t('fullNameRequired') }}</span>
                <span *ngIf="checkoutForm.get('fullName')?.errors?.['minlength']">{{ t('fullNameMinLength') }}</span>
              </div>
            </div>

            <div class="form-group">
              <label for="mobile">
                <i class="fas fa-mobile-alt"></i>
                {{ t('mobileNumber') }} *
              </label>
              <div class="input-wrapper">
                <input type="tel" id="mobile" formControlName="mobile" [placeholder]="t('enterMobileNumber')"
                  class="form-control" [class.error]="checkoutForm.get('mobile')?.invalid && checkoutForm.get('mobile')?.touched">
                <div class="input-icon">
                  <i class="fas fa-mobile-alt"></i>
                </div>
              </div>
              <div class="error-message"
                *ngIf="checkoutForm.get('mobile')?.invalid && checkoutForm.get('mobile')?.touched">
                <i class="fas fa-exclamation-triangle"></i>
                <span *ngIf="checkoutForm.get('mobile')?.errors?.['required']">{{ t('mobileRequired') }}</span>
                <span *ngIf="checkoutForm.get('mobile')?.errors?.['pattern']">{{ t('validMobileRequired') }}</span>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="address">
              <i class="fas fa-home"></i>
              {{ t('deliveryAddress') }} *
            </label>
            <div class="input-wrapper">
              <textarea id="address" formControlName="address" [placeholder]="t('enterDeliveryAddress')" rows="3"
                class="form-control" [class.error]="checkoutForm.get('address')?.invalid && checkoutForm.get('address')?.touched"></textarea>
              <div class="input-icon">
                <i class="fas fa-home"></i>
              </div>
            </div>
            <div class="error-message"
              *ngIf="checkoutForm.get('address')?.invalid && checkoutForm.get('address')?.touched">
              <i class="fas fa-exclamation-triangle"></i>
              <span *ngIf="checkoutForm.get('address')?.errors?.['required']">{{ t('addressRequired') }}</span>
              <span *ngIf="checkoutForm.get('address')?.errors?.['minlength']">{{ t('addressMinLength') }}</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="pincode">
                <i class="fas fa-map-pin"></i>
                {{ t('pincode') }} *
              </label>
              <div class="input-wrapper">
                <input type="text" id="pincode" formControlName="pincode" [placeholder]="t('enterPincode')"
                  class="form-control" maxlength="6" [class.error]="checkoutForm.get('pincode')?.invalid && checkoutForm.get('pincode')?.touched">
                <div class="input-icon">
                  <i class="fas fa-map-pin"></i>
                </div>
              </div>
              <div class="error-message"
                *ngIf="checkoutForm.get('pincode')?.invalid && checkoutForm.get('pincode')?.touched">
                <i class="fas fa-exclamation-triangle"></i>
                <span *ngIf="checkoutForm.get('pincode')?.errors?.['required']">{{ t('pincodeRequired') }}</span>
                <span *ngIf="checkoutForm.get('pincode')?.errors?.['pattern']">{{ t('validPincodeRequired') }}</span>
              </div>
            </div>

            <div class="form-group">
              <label for="city">
                <i class="fas fa-city"></i>
                {{ t('city') }} *
              </label>
              <div class="input-wrapper">
                <input type="text" id="city" formControlName="city" [placeholder]="t('enterCity')" class="form-control" [attr.disabled]="true">
                <div class="input-icon">
                  <i class="fas fa-city"></i>
                </div>
              </div>
              <small class="form-hint">
                <i class="fas fa-info-circle"></i>
                {{ t('autoFilledFromPincode') }}
              </small>
            </div>
          </div>

          <div class="form-group">
            <label for="state">
              <i class="fas fa-map"></i>
              {{ t('state') }} *
            </label>
            <div class="input-wrapper">
              <input type="text" id="state" formControlName="state" [placeholder]="t('enterState')" class="form-control" [attr.disabled]="true">
              <div class="input-icon">
                <i class="fas fa-map"></i>
              </div>
            </div>
            <small class="form-hint">
              <i class="fas fa-info-circle"></i>
              {{ t('autoFilledFromPincode') }}
            </small>
          </div>

          <!-- Payment Method Selection -->
          <div class="form-group">
            <label>
              <i class="fas fa-credit-card"></i>
              {{ t('paymentMethod') }} *
            </label>
            <div class="payment-method-selection">
              <!-- VyaparGateway (Default - UPI Only) -->
              <div class="payment-option" 
                   [class.selected]="selectedPaymentMethod === 'vyapargateway'"
                   (click)="selectPaymentMethod('vyapargateway')">
                <div class="payment-option-icon">
                  <i class="fas fa-mobile-alt"></i>
                </div>
                <div class="payment-option-details">
                  <h4>UPI Payment (VyaparGateway)</h4>
                  <p>Pay via UPI - GPay, PhonePe, Paytm (0% fees)</p>
                </div>
                <div class="payment-option-radio">
                  <input type="radio" 
                         name="paymentMethod" 
                         formControlName="paymentMethod" 
                         value="vyapargateway"
                         [checked]="selectedPaymentMethod === 'vyapargateway'">
                </div>
              </div>

              <!-- Razorpay (Backup - Cards, Wallets, Net Banking) -->
              <div class="payment-option" 
                   [class.selected]="selectedPaymentMethod === 'razorpay'"
                   (click)="selectPaymentMethod('razorpay')">
                <div class="payment-option-icon">
                  <i class="fas fa-shield-alt"></i>
                </div>
                <div class="payment-option-details">
                  <h4>Card/Net Banking/Wallet (Razorpay)</h4>
                  <p>{{ t('paySecurelyWithCardsNetBankingOrWallets') }}</p>
                </div>
                <div class="payment-option-radio">
                  <input type="radio" 
                         name="paymentMethod" 
                         formControlName="paymentMethod" 
                         value="razorpay"
                         [checked]="selectedPaymentMethod === 'razorpay'">
                </div>
              </div>

              <!-- <div class="payment-option" 
                   [class.selected]="selectedPaymentMethod === 'cod'"
                   [class.disabled]="!deliveryChargesFetched || !selectedCourier || codNotAvailableReason"
                   (click)="deliveryChargesFetched && selectedCourier && !codNotAvailableReason && selectPaymentMethod('cod')">
                <div class="payment-option-icon">
                  <i class="fas fa-money-bill-wave"></i>
                </div>
                <div class="payment-option-details">
                  <h4>{{ t('cashOnDelivery') }}</h4>
                  <p *ngIf="deliveryChargesFetched && selectedCourier && !codNotAvailableReason" class="success-text">{{ t('payWhenYouReceiveOrder') }}</p>
                  <p *ngIf="!deliveryChargesFetched" class="warning-text">{{ t('enterDeliveryPincodeToCheckCOD') }}</p>
                  <p *ngIf="codNotAvailableReason" class="error-text">
                    <i class="fas fa-exclamation-circle"></i> {{ codNotAvailableReason }}
                  </p>
                  <p *ngIf="deliveryChargesFetched && !selectedCourier && !codNotAvailableReason" class="warning-text">{{ t('codNotAvailableForLocation') }}</p>
                </div>
                <div class="payment-option-radio">
                  <input type="radio" 
                         name="paymentMethod" 
                         formControlName="paymentMethod" 
                         value="cod"
                         [checked]="selectedPaymentMethod === 'cod'"
                         [disabled]="!deliveryChargesFetched || !selectedCourier || !!codNotAvailableReason">
                </div>
              </div> -->
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Right Column - Order Summary -->
    <div class="product-details-column">
      <div class="checkout-section order-summary">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-receipt"></i>
          </div>
          <h2>{{ t('orderSummary') }}</h2>
        </div>
        
        <!-- Cart Items -->
        <div class="cart-items">
          <div class="cart-item" *ngFor="let item of cartItems">
            <div class="item-image">
              <img [src]="item.image[0]" [alt]="getLocalizedName(item)">
            </div>
            <div class="item-details">
              <h3>{{ getDisplayNameWithCategory(item) }}</h3>
              <p class="item-description">{{ getLocalizedDescription(item) }}</p>
              <!-- Items in box display -->
              <p class="sub-products" *ngIf="getSubProducts(item)">
                <span class="sub-products-label">{{ t('itemsInBox') || 'Items in box' }}:</span>
                <span class="sub-products-list">{{ getSubProducts(item) }}</span>
              </p>
              <!-- Price display -->
              <div class="item-price-display">
                <div class="price">₹{{ getItemUnitPrice(item) | number:'1.2-2' }}</div>
                <div class="original-price" *ngIf="hasOfferPrice(item)">
                  <span class="og-price">₹{{ getItemUnitOriginalPrice(item)! | number:'1.2-2' }}</span>
                </div>
                <div class="quantity-info" *ngIf="item.cartQuantity > 1">
                  <span class="qty-label">Qty:</span>
                  <span class="qty-value">{{ item.cartQuantity }}</span>
                  <span class="total-price">Total: ₹{{ (getItemUnitPrice(item) * item.cartQuantity) | number:'1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Summary Items -->
        <div class="summary-items">
          <div class="summary-item">
            <span>
              <i class="fas fa-shopping-cart"></i>
              {{ t('subtotal') }}:
            </span>
            <span>
              ₹
              {{ subtotal }}
            </span>
          </div>
          <div class="summary-item discount" *ngIf="discount > 0">
            <span>
              <i class="fas fa-tag"></i>
              {{ t('discount') }}:
            </span>
            <span>
              -₹
              {{ discount }}
            </span>
          </div>
          <div class="summary-item">
            <span>
              <i class="fas fa-truck"></i>
              {{ t('deliveryCharge') }}:
            </span>
            <span *ngIf="!isCalculatingDelivery">
              <small *ngIf="selectedCourier" class="courier-info">
                ({{ t('estDelivery') }}: {{ selectedCourier.estimated_delivery_days }} {{ t('days') }})
              </small>
              ₹{{ deliveryCharges }}
            </span>
            <span *ngIf="isCalculatingDelivery" class="calculating-text">
              <i class="fas fa-spinner fa-spin"></i> {{ t('calculatingDeliveryCharges') }}
            </span>
          </div>
          <div class="summary-item total">
            <span>
              <i class="fas fa-calculator"></i>
              {{ t('total') }}:
            </span>
            <span>
              ₹
              {{ total }}
            </span>
          </div>
          <div class="summary-item">
            <span>
              <i class="fas fa-credit-card"></i>
              {{ t('paymentMethod') }}:
            </span>
            <span>{{ getPaymentMethodName() }}</span>
          </div>
        </div>
        
        <div class="razorpay-processing" *ngIf="isLoading && selectedPaymentMethod === 'razorpay'">
          <div class="spinner"></div>
          <p>{{ t('processingPayment') }}</p>
          <small>{{ t('pleaseWait') }}</small>
        </div>

        <!-- VyaparGateway QR Code Display (Desktop) -->
        <div class="vyapar-qr-section" *ngIf="showVyaparQR && selectedPaymentMethod === 'vyapargateway'">
          <div class="qr-container">
            <h4>Scan QR Code to Pay</h4>
            <img [src]="vyaparQRCode" alt="UPI Payment QR Code" class="qr-code-image">
            <p>Amount: ₹{{ total }}</p>
            <p class="qr-instruction">Open any UPI app (GPay, PhonePe, Paytm) and scan this QR code</p>
            <button class="btn btn-secondary" (click)="cancelVyaparPayment()">Cancel</button>
            <button class="btn btn-primary" (click)="checkVyaparPaymentStatus()">I've Paid</button>
          </div>
        </div>

        <!-- Place Order Button -->
        <div class="checkout-actions" *ngIf="!orderPlaced">
          <button type="submit" class="btn btn-primary btn-large" 
            [disabled]="checkoutForm.invalid || isLoading || isCalculatingDelivery || !deliveryChargesFetched"
            (click)="placeOrder()">
            <i class="fas fa-shopping-cart" *ngIf="!isLoading"></i>
            <div class="spinner-small" *ngIf="isLoading"></div>
            <span *ngIf="!isLoading">{{ t('placeOrder') }}</span>
            <span *ngIf="isLoading">{{ t('processing') }}</span>
          </button>
          <small *ngIf="!deliveryChargesFetched && !isCalculatingDelivery" class="form-hint">
            <i class="fas fa-info-circle"></i>
            {{ t('enterValidPincodeToCalculateDelivery') }}
          </small>
          <small *ngIf="isCalculatingDelivery" class="form-hint">
            <i class="fas fa-spinner fa-spin"></i>
            {{ t('calculatingDeliveryCharges') }}
          </small>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Section - Payment Method Details -->
  <div class="payment-methods-section">
    <div class="checkout-section">
      <div class="section-header">
        <div class="section-icon">
          <i class="fas fa-credit-card"></i>
        </div>
        <h2>{{ t('paymentMethod') }}</h2>
      </div>

      <!-- Payment Security Info -->
      <div class="payment-security-info">
        <div class="security-badges">
          <div class="security-badge">
            <i class="fas fa-lock"></i>
            <span>{{ t('paymentSecurity_ssl') }}</span>
          </div>
          <div class="security-badge">
            <i class="fas fa-shield-alt"></i>
            <span>{{ t('paymentSecurity_pci') }}</span>
          </div>
          <div class="security-badge">
            <i class="fas fa-check-circle"></i>
            <span>{{ t('paymentSecurity_secure') }}</span>
          </div>
        </div>
        <p class="payment-note">
          <i class="fas fa-info-circle"></i>
          {{ t('paymentSecurity_note') }}
        </p>
      </div>
    </div>
  </div>


    <!-- Success Messages -->
    <div class="success-message-container" *ngIf="successMessage">
      <div class="alert alert-success">
        <i class="fas fa-check-circle"></i>
        {{ successMessage }}
      </div>
    </div>

    <!-- Order Confirmation / Error -->
    <div class="order-confirmation" *ngIf="orderPlaced || paymentError">
      <div class="confirmation-card" [ngClass]="{'error-state': paymentError}">
        <!-- Success State -->
        <div *ngIf="orderPlaced && !paymentError">
          <div class="confirmation-icon success-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <h3>{{ t('orderPlacedSuccessfully') }}</h3>
          <p>{{ t('paymentSuccessful') }}</p>
          <p>{{ t('orderId') }}: <strong>{{ orderId }}</strong></p>
          <p>{{ t('thankYouMessage') }}</p>
          <div class="confirmation-actions">
            <button class="btn btn-primary" (click)="goToHome()">
              <i class="fas fa-home"></i>
              {{ t('goToHome') }}
            </button>
            <button class="btn btn-secondary" (click)="trackOrder()">
              <i class="fas fa-truck"></i>
              {{ t('trackOrder') }}
            </button>
          </div>
        </div>

        <!-- Error State -->
        <div *ngIf="paymentError">
          <div class="confirmation-icon error-icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <h3>{{ t('paymentFailed') }}</h3>
          <p>{{ t('orderNotPlaced') }}</p>
          <p class="error-message">{{ errorMessage || t('paymentErrorMessage') }}</p>
          <div class="confirmation-actions">
            <button class="btn btn-primary" (click)="retryPayment()">
              <i class="fas fa-redo"></i>
              {{ t('retryPayment') }}
            </button>
            <button class="btn btn-secondary" (click)="goToHome()">
              <i class="fas fa-home"></i>
              {{ t('goToHome') }}
            </button>
          </div>
        </div>
      </div>
    </div>
</div>